// Long enough to suppress a hard waveform discontinuity, short enough that
// transport still feels instantaneous. This is a gain envelope, not an
// editorial content fade.
export const TRANSPORT_DECLICK_MS = 35;

// Leave enough headroom for one 60 Hz animation frame before starting the
// sample-accurate gain ramp.
export const NATURAL_END_ENVELOPE_WINDOW_MS = 70;

type NaturalEndEnvelopeState = {
  alreadyArmed: boolean;
  currentTime: number;
  duration: number;
  externalPlayback: boolean;
  muted: boolean;
  paused: boolean;
  playingIntent: boolean;
};

export function shouldBeginNaturalEndEnvelope({
  alreadyArmed,
  currentTime,
  duration,
  externalPlayback,
  muted,
  paused,
  playingIntent
}: NaturalEndEnvelopeState) {
  const remainingSeconds = duration - currentTime;
  return (
    !alreadyArmed &&
    playingIntent &&
    !paused &&
    !muted &&
    !externalPlayback &&
    Number.isFinite(remainingSeconds) &&
    remainingSeconds > 0 &&
    remainingSeconds <= NATURAL_END_ENVELOPE_WINDOW_MS / 1_000
  );
}
